export const alertsFront = (alertsDesign = "") => {

    // Move original warning tags to here
    // 
    const orgAlertsElement = document.getElementById("warnings_container");
    let newAlertsElementString = ``;
    if(orgAlertsElement!=undefined) {
        newAlertsElementString = orgAlertsElement.outerHTML;
        orgAlertsElement.id = "warnings_container_org";
        orgAlertsElement.className = "warnings_org d-none";
    }
    return newAlertsElementString;
}
